cb.define(['common/common_VM.Extend.js'], function (common) {
  var AA_aa_storelevel_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      let params = viewmodel.getParams();
      let mode = params && params.mode || env.VOUCHER_STATE_BROWSE;
      let gridModel = viewmodel.getGridModel();
      if (mode === "browse") {
        viewmodel.get("btnSave").setVisible(false);
        viewmodel.get("btnSaveAndAdd").setVisible(false);
        viewmodel.get("btnAbandon").setVisible(false);
      }else if (mode === "edit") {
	     viewmodel.get("btnSaveAndAdd").setVisible(false);
	  }

    }
  }
  try {
    module.exports = AA_aa_storelevel_VM_Extend;
  } catch (error) {

  }
  return AA_aa_storelevel_VM_Extend;
});




// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_storelevel_VM.Extend.js